import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import './StringIncludesPolyfill'
import React from 'react'
import { render } from 'react-dom'
import RootContainer from './features/root/RootContainer'
import './index.css';
import registerServiceWorker from './registerServiceWorker';
 
render(
  <RootContainer />, 
  document.getElementById('root')
)

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js